export enum HostingType {
  SINGERLY = 'singerly',
  ONPREMISES = 'on-premises',
}
